import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

export const ACCESS_DENIED_ROUTE = '/access-denied';

export interface AccessDeniedInfo {
  /** Privileges the page needs (user must hold at least one). */
  privileges?: string[];
  /** Server-provided reason, when the denial came from an HTTP 403. */
  message?: string;
  /** URL the user tried to open. */
  from?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  private router = inject(Router);

  /** Build the URL tree of the in-page access denied screen. */
  denyTree(info: AccessDeniedInfo = {}): UrlTree {
    const queryParams: Record<string, string> = {};
    if (info.privileges?.length) queryParams['privileges'] = info.privileges.join(',');
    if (info.message) queryParams['message'] = info.message;
    if (info.from) queryParams['from'] = info.from;
    return this.router.createUrlTree([ACCESS_DENIED_ROUTE], { queryParams });
  }

  /** Navigate to the access denied screen (for non-guard callers, e.g. HTTP 403). */
  deny(info: AccessDeniedInfo = {}): void {
    this.router.navigateByUrl(this.denyTree({ from: this.router.url, ...info }), {
      skipLocationChange: false,
    });
  }
}
